import { supabase } from "./supabase";

export type AuditEntityType =
  | "task"
  | "complaint"
  | "calibration"
  | "preparation"
  | "document";

export type AuditAction =
  | "completed"
  | "cancelled"
  | "resolved"
  | "closed"
  | "calibrated"
  | "approved"
  | "rejected"
  | "validated";

export interface AuditEntry {
  pharmacy_id: string;
  user_id: string;
  user_name: string;
  action: AuditAction;
  entity_type: AuditEntityType;
  entity_id?: string;
  entity_label?: string;
  details?: Record<string, unknown>;
}

/**
 * Insert an audit log entry. Only call this after an action has successfully
 * completed — never on intermediate state changes.
 * Errors are swallowed so audit logging never breaks the main flow.
 */
export async function logAuditEvent(entry: AuditEntry): Promise<void> {
  try {
    const { error } = await supabase.from("audit_logs").insert({
      pharmacy_id: entry.pharmacy_id,
      user_id: entry.user_id,
      user_name: entry.user_name,
      action: entry.action,
      entity_type: entry.entity_type,
      entity_id: entry.entity_id ?? null,
      entity_label: entry.entity_label ?? null,
      details: entry.details ?? null,
    });
    if (error) {
      console.warn("Audit log insert failed:", error.message);
    }
  } catch {
    // Audit logging must never break the main flow
  }
}
